import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-turbine-icon',
    templateUrl: './turbine-icon.component.html',
    styleUrls: ['./turbine-icon.component.scss'],
    standalone: false
})
export class TurbineIconComponent implements OnInit {

  @Input() color: string;

  constructor() { }

  ngOnInit() {
  }

}
